import { CommonModule } from '@angular/common';
import { Component, inject, type OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { SanitizeSrcPipe } from '@shared/pipes/sanitize-src.pipe';
import { PlainHtmlComponent } from '@widgets/plain-html/plain-html.component';

import {
  type ICompanyServiceOffering,
  SERVICE_LOGICAL_STATUS,
} from '../../../models/services.model';
import { ServiceLogicalStatusPipe } from '../../../pipes/service-logical-status.pipe';

@UntilDestroy()
@Component({
  selector: 'ume-company-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    ServiceLogicalStatusPipe,
    SanitizeSrcPipe,
    PlainHtmlComponent,
  ],
})
export class CompanyServicesPageComponent implements OnInit {
  readonly serviceLogicalStatus = SERVICE_LOGICAL_STATUS;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  public services: ICompanyServiceOffering[] = [];

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this)).subscribe((data) => {
      this.services = data.services;
    });
  }

  public linkAction(offeringId: string): void {
    if (offeringId) {
      void this.router.navigate(['/', 'my-account', 'service', offeringId, 'configuration']);
    }
  }
}
